/**
 * Safely gets a nested property value from an object using dot notation or array notation
 * @param obj - The object to get the value from
 * @param path - The path to the property (e.g., 'user.name' or ['user', 'name'])
 * @param defaultValue - The default value to return if the property doesn't exist
 * @returns The value at the path or the default value
 */
export function get<T = any>(
  obj: any,
  path: string | string[],
  defaultValue?: T,
): T {
  if (!obj || typeof obj !== "object") {
    return defaultValue as T;
  }

  const pathArray = Array.isArray(path) ? path : path.split(".");
  let current = obj;

  for (const key of pathArray) {
    if (current == null || typeof current !== "object") {
      return defaultValue as T;
    }
    current = current[key];
  }

  return current !== undefined ? current : (defaultValue as T);
}
